import { useCallback } from "react";
import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
  Link,
} from "@tanstack/react-router";
import { LayoutGrid, Table2, CalendarDays, Plus } from "lucide-react";
import { FullscreenButton } from "@/components/ui/fullscreen-button";
import { Button } from "@/components/ui/button";
import { ViewToggleTabs } from "@/components/navigation/view-toggle-tabs";

export const Route = createFileRoute(
  "/_authenticated/logistics/containers/_list",
)({
  component: ConsolidadosListLayout,
});

const VIEW_OPTIONS = [
  { value: "table" as const, label: "Lista", icon: Table2 },
  { value: "kanban" as const, label: "Kanban", icon: LayoutGrid },
  { value: "calendar" as const, label: "Calendario", icon: CalendarDays },
];

type ViewKey = (typeof VIEW_OPTIONS)[number]["value"];

const VIEW_PATHS: Record<ViewKey, string> = {
  table: "/logistics/containers",
  kanban: "/logistics/containers/kanban",
  calendar: "/logistics/containers/calendar",
};

const PATH_TO_VIEW: Record<string, ViewKey> = {
  "/logistics/containers": "table",
  "/logistics/containers/": "table",
  "/logistics/containers/kanban": "kanban",
  "/logistics/containers/calendar": "calendar",
};

function ConsolidadosListLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentView = PATH_TO_VIEW[location.pathname] ?? "table";

  const handleViewChange = useCallback(
    (view: ViewKey) => {
      navigate({ to: VIEW_PATHS[view] });
    },
    [navigate],
  );

  return (
    <div className="flex-1 flex flex-col min-h-0 h-full overflow-hidden gap-2">
      <div className="flex items-center justify-between pb-1 flex-shrink-0">
        <ViewToggleTabs
          options={VIEW_OPTIONS}
          value={currentView}
          onChange={handleViewChange}
          size="default"
          showLabels="responsive"
          alignment="left"
          variant="default"
        />
        <Link to="/logistics/containers/new">
          <Button size="sm" className="h-7 text-xs gap-1.5">
            <Plus className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Nuevo Contenedor</span>
          </Button>
        </Link>
      </div>
      <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
        <Outlet />
      </div>
      <FullscreenButton />
    </div>
  );
}
